<dx-list
  #listRef
  [items]="associationsDataSourceSig()"
  [selectionMode]="'single'"
  [showSelectionControls]="true"
  [keyExpr]="'key'"
  [displayExpr]="'description'"
  [selectedItemKeys]="selectedAssociationKeysSig()"
  [disabled]="isReadonly"
  [visible]="isListVisible"
  (onItemClick)="handleSelectAssociation($event)"
></dx-list>

<ng-content></ng-content>
